export const TRIP_TYPES = {
  ONE_WAY: 'ONE_WAY',
  RETURN: 'RETURN',
  MULTI_DESTINATION: 'MULTI_DESTINATION',
} as const;

export type TripType = keyof typeof TRIP_TYPES;

export const { MULTI_DESTINATION, ONE_WAY, RETURN } = TRIP_TYPES;

export type OneWay = typeof TRIP_TYPES.ONE_WAY;
export type Return = typeof TRIP_TYPES.RETURN;
export type MultiDestination = typeof TRIP_TYPES.MULTI_DESTINATION;

export const ONE_WAY_PROTO = 'ONE_WAY';
export const RETURN_PROTO = 'RETURN';
export const MULTI_DESTINATION_PROTO = 'MULTI_CITY';
